type ScrollType = 'smooth' | 'auto';

export const scrollToElement = (element?: HTMLElement | null, scrollType: ScrollType = 'smooth') => {
  if (element && window) {
    const rect = element.getBoundingClientRect();
    const offset = rect.top + window.scrollY;
    window.scrollTo({ top: offset, behavior: scrollType });
  }
};
